import { useSessionStorage } from 'react-use'
import {
  JoinToSpeakIsJoiningToSpeakSessionStorageKey,
  JoinToSpeakHasJoinedToSpeakSessionStorageKey,
} from './constants'

function useIsJoiningToSpeak(sessionId: string) {
  return useSessionStorage(
    `${sessionId}_${JoinToSpeakIsJoiningToSpeakSessionStorageKey}`,
    false
  )
}

function useHasJoinedToSpeak(sessionId: string) {
  return useSessionStorage(
    `${sessionId}_${JoinToSpeakHasJoinedToSpeakSessionStorageKey}`,
    false
  )
}

export { useIsJoiningToSpeak, useHasJoinedToSpeak }
